<div class="datepicker-wrapper" [class.fluid]="fluid()">
  <label *ngIf="label()" [for]="id()" class="input-label">{{ label() }}</label>
  <p-datepicker
    [inputId]="id()"
    [ngModel]="value()"
    (ngModelChange)="value.set($event)"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    [readonlyInput]="readonly()"
    [selectionMode]="selectionMode()"
    [dateFormat]="dateFormat()"
    [showTime]="showTime()"
    [showIcon]="showIcon()"
    [iconDisplay]="iconDisplay()"
    [showButtonBar]="showButtonBar()"
    [showWeek]="showWeek()"
    [numberOfMonths]="numberOfMonths()"
    [view]="view()"
    [minDate]="minDate()!"
    [maxDate]="maxDate()!"
    [appendTo]="appendTo()"
    [inline]="inline()"
    [touchUI]="touchUI()"
    [styleClass]="styleClass()"
    [fluid]="fluid()"
    [showClear]="showClear()"
    (onSelect)="handleSelect($event)"
    (onClear)="handleClear()"
    [size]="size()">
  </p-datepicker>
</div>
